import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/site/nav/`,
    detail: (id) => `${BASE_URL}/api/v1/site/nav/${id}/`,
};

export const siteNavLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const siteNavDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const siteNavUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const siteNavDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
